// extracted by mini-css-extract-plugin
export default {"root":"version_root__-oczU"};